function AddToCalendar(el) {
	var t = this,
			activeClass = 'addtocalendar--active';
	t.el = el;
	t.list = t.el.querySelector('.atcb-list');
	t.toggle = t.el.querySelector('[data-atc-toggle]');
	t.link = t.list.querySelectorAll('.atcb-item-link');

	t.toggle.addEventListener('click', function() {
		var activeEl = document.activeElement;

		while (activeEl !== document.documentElement) {
			if (activeEl === el) {
				t.el.classList.toggle(activeClass);
				console.log('test');

				return;
			}

			activeEl = activeEl.parentNode;
		}
	});

	document.documentElement.addEventListener('click', function(e) {
		var target = e.target;
		while (target !== document.documentElement) {
			if (target.classList.contains( activeClass )) {
				return;
			}
			target = target.parentNode;
		}
		t.el.classList.remove( activeClass );
	});

	// Fix tabindex problem
	window.addEventListener('load', function() {
		t.toggle.tabIndex = 0;
	});

	// Keyboard accessibility
	var timeout = 0;
	var openPopup = function() {
		clearTimeout(timeout);
		t.el.classList.add(activeClass);
	};

	var closePopup = function() {
		clearTimeout(t);
		timeout = setTimeout(function() {
			t.el.classList.remove(activeClass);
		}, 50);
	};

	t.toggle.addEventListener('focus', function(e) {
		if (e.relatedTarget) {
			openPopup();
		}
	});

	t.toggle.addEventListener('blur', closePopup);

	t.link.forEach(function(link) {
		link.addEventListener('focus', openPopup);
		link.addEventListener('blur', closePopup);
	});
}
module.exports = AddToCalendar;
